import { Component, OnInit } from '@angular/core';
import { MatDialogRef as MatDialogRef, MatDialogContent, MatDialogClose } from '@angular/material/dialog';
import { ModalHeaderComponent } from '../modal-header/modal-header.component';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';

@Component({
    standalone: true,
    selector: 'app-characters',
    templateUrl: './characters.component.html',
    styleUrls: ['./characters.component.css'],
    imports: [ModalHeaderComponent, CdkScrollable, MatDialogContent, MatButton, MatDialogClose]
})
export class CharactersComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<CharactersComponent>
  ) { }

  ngOnInit() {
  }

  close(){
    this.dialogRef.close();
  }

}
